import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'

import './index.less'

import { Typography, Row, Col, Progress } from 'antd'
import { Advertising } from '/components/Advertising'

const { Text } = Typography

// The period by which we will increase the progress bar
const PROGRESS_INTERVAL = 20

export const Countdown = ({ countdownCallback, timeLeft }) => {
  const [state, setState] = useState({
    done: false,
    percent: 0,
    timeLeft: timeLeft * 1000,
    steps: Math.floor((timeLeft * 1000) / PROGRESS_INTERVAL),
    percentInc: 100 / ((timeLeft * 1000) / PROGRESS_INTERVAL),
  })

  const [isAdvertisingVisible, setAdvertisingVisibility] = useState(false)

  let progressInterval

  useEffect(() => {
    // Display advertising 1 sec after the countdown has started
    setTimeout(displayAdvertising, 1000)
  }, [])

  useEffect(() => {
    progressInterval = setInterval(checkProgress, PROGRESS_INTERVAL)

    return () => clearInterval(progressInterval)
  }, [state.timeLeft])

  const checkProgress = () => {
    const { timeLeft, percentInc } = state

    if (timeLeft > 0) {
      setState(({ percent, timeLeft }) => ({
        ...state,
        percent: percent + percentInc,
        timeLeft: timeLeft - PROGRESS_INTERVAL,
      }))
    } else {
      clearInterval(progressInterval)
      setState({ ...state, done: true })
      countdownCallback()
    }
  }

  const displayAdvertising = () => {
    setAdvertisingVisibility(true)
  }

  const handleAdvertisingCancel = useCallback(() => {
    setAdvertisingVisibility(false)
  }, [])

  return (
    <Row style={{ height: '100%' }}>
      <Col
        xs={{ span: 20, offset: 2 }}
        lg={{ span: 13, offset: 7 }}
        xl={{ offset: 7 }}
        xxl={{ offset: 6 }}
        id='div-count'
      >
        <Text style={{ fontSize: 20 }}>
          Aguarde enquanto raspamos seu código!
        </Text>
        <div>
          {state.timeLeft > 500 ? (
            <Progress
              type='circle'
              percent={state.percent}
              format={() => `${Math.round(state.timeLeft / 1000)}`}
              id='countdown'
            />
          ) : (
            <Progress type='circle' percent={100} id='countdown' />
          )}
        </div>
        <Advertising
          isVisible={isAdvertisingVisible}
          handleCancel={handleAdvertisingCancel}
        />
      </Col>
    </Row>
  )
}

Countdown.propTypes = {
  /** Callback to be executed once the countdown is done */
  countdownCallback: PropTypes.func.isRequired,

  /** The countdown time */
  timeLeft: PropTypes.number,
}
